import T from "./T";

export const contactTypesLang = () => {
    return {
        PHONE: T('Phone'),
        EMAIL: T('E-mail address')
    }
};